import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
import {downloadFile} from '../../common/util/file';

const INITIAL_STATE_MANAGE_DATES = {
  'vehicles': [],
  'excel': '',
  'loading': false,
};

export const listVehicleCertification = (state, action) => {
  return createReducer(INITIAL_STATE_MANAGE_DATES, {
    [ActionTypes.FETCHING_LIST_VEHICLE_CERTIFICATION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_LIST_VEHICLE_CERTIFICATION]: (state, action) => ({
      ...state,
      'loading': false,
      'vehicles': action.response.data,
    }),
    [ActionTypes.FETCHED_LIST_VEHICLE_CERTIFICATION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'vehicles': [],
    }),
    [ActionTypes.FETCHING_XLSX_CERTIFICATION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_XLSX_CERTIFICATION]: (state, action) => ({
      ...state,
      'excel': action.response.data,
      'loading': false,
    }),
    [ActionTypes.FETCHED_XLSX_CERTIFICATION_FAILED]: (state, action) => ({
      ...state,
      'excel': '',
      'loading': false,
    }),
  })(state, action);
};

const INITIAL_STATE_PDF_CERTIFICATE = {
  'pdf': null,
  'loadingPdf': false,
};


export const pdfCertificate = (state, action) => {
  return createReducer(INITIAL_STATE_PDF_CERTIFICATE, {
    [ActionTypes.FETCHING_PDF_CERTIFICATION]: (state, action) => ({
      ...state,
      'loadingPdf': true,
    }),
    [ActionTypes.FETCHED_PDF_CERTIFICATION]: (state, action) => {
      downloadFile(action.response.data);
      return {
        ...state,
        'loadingPdf': false,
        'pdf': action.response.data,
        'id': action.payload,
      };
    },
    [ActionTypes.FETCHED_PDF_CERTIFICATION_FAILED]: (state, action) => ({
      ...state,
      'loadingPdf': false,
      'pdf': null,
    }),
    [ActionTypes.CLEAR_PDF_CERTIFICATION]: (state, action) => ({
      ...state,
      ...INITIAL_STATE_PDF_CERTIFICATE,
    }),
  })(state, action);
};


const INITIAL_STATE_CERTICATE_OWNER = {
  'certificate': null,
  'loading': false,
};

export const certificateOwner = (state, action) => {
  return createReducer(INITIAL_STATE_CERTICATE_OWNER, {
    [ActionTypes.FETCHING_VEHICLE_CERTIFICATE_OWNER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLE_CERTIFICATE_OWNER]: (state, action) => {
      downloadFile(action.response.data);
      return {
        ...state,
        'loading': false,
        'certificate': action.response.data,
        'id': action.payload,
      };
    },
    [ActionTypes.FETCHED_VEHICLE_CERTIFICATE_OWNER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'certificate': null,
    }),
    [ActionTypes.CLEAR_VEHICLE_CERTIFICATION_OWNER]: (state, action) => ({
      ...state,
      ...INITIAL_STATE_CERTICATE_OWNER,
    }),
  })(state, action);
};


const INITIAL_STATE_CPO_LABEL = {
  'label': null,
  'loading': false,
};

export const cpoLabel = (state, action) => {
  return createReducer(INITIAL_STATE_CPO_LABEL, {
    [ActionTypes.FETCHING_VEHICLE_CPO_LABEL]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLE_CPO_LABEL]: (state, action) => {
      downloadFile(action.response.data);
      return {
        ...state,
        'loading': false,
        'label': action.response.data,
        'id': action.payload,
      };
    },
    [ActionTypes.FETCHED_VEHICLE_CPO_LABEL_FAILED]: (state, action) => ({
      ...state,
      ...INITIAL_STATE_CPO_LABEL,
    }),
    [ActionTypes.CLEAR_VEHICLE_CPO_LABEL]: (state, action) => ({
      ...state,
      ...INITIAL_STATE_CPO_LABEL,
    }),
  })(state, action);
};
